'use client'
import { FC, ReactNode, useMemo } from 'react'
import { MdClose, MdOutlineMenu } from 'react-icons/md'

import { useModal, useSlideOut } from '#/src/custom/controllers'
import { RequiredPageProps } from 'ecosystem'
import { useAppConfigContext } from '#/src/appConfig'
import { MenuItem, TopNavSpacer } from 'ui/storefront'
import { TopNav } from './custom-layout-components/TopNav/TopNav'
import CustomFooter from '#/src/custom/layout/CustomFooter'
import { Box } from '@chakra-ui/react'
import { PageLayoutContainer } from 'storefront-modules/page'
import { TopNavLogo } from '#/src/custom/layout/TopNavLogo'

export type CustomLayoutProps = RequiredPageProps & {
  children: ReactNode | ReactNode[]
}

const CustomLayout: FC<CustomLayoutProps> = ({
  children,
  footerWidgets,
  staticPages,
  categories
}) => {
  const appConfig = useAppConfigContext()
  const { isHidden, closeSlideOut, openSlideOut, componentId } = useSlideOut()
  const { isHidden: isModalHidden, size: modalSize } = useModal()

  // Granditude navigation links
  const staticLinks = useMemo(() => {
    return appConfig.staticLinks.length > 1
      ? appConfig.staticLinks
      : [
          { id: 'what-we-do', label: 'What We Do', path: '/what-we-do' },
          { id: 'partners', label: 'Partners & Integrations', path: '/partners' },
          { id: 'working-together', label: 'Working Together', path: '/working-together' }
        ]
  }, [appConfig.staticLinks])

  const menuItems: {
    other: MenuItem[]
  } = useMemo(() => {
    return {
      other: [
        // ...(staticPages
        //   ? staticPages.map((sp) => ({
        //       id: 'other-' + sp.id,
        //       text: sp.name,
        //       path: sp.slug ? `/${sp.slug}` : '/',
        //       onHoverEnter: () => closeSlideOut()
        //     }))
        //   : []),
        ...staticLinks.map(({ label, ...s }) => ({
          ...s,
          text: label,
          onHoverEnter: () => closeSlideOut()
        }))
      ]
    }
  }, [closeSlideOut, staticLinks])

  const logoComponent = <TopNavLogo />

  const handleOnMenuToggle = (menuItems: MenuItem[]) => {
    if (isHidden) {
      openSlideOut({
        title: '',
        componentId: 'mobileMenu',
        footerId: 'mobileMenu',
        extraArgs: {
          menuItems
        },
        drawerProps: {
          sx: {
            '.GrandHeading': {
              textTransform: 'none !important'
            }
          }
        }
      })
    } else {
      closeSlideOut()
    }
  }

  const handleOnMenuHover = (isInSide: boolean) => {
    if (isInSide && componentId === 'categories') {
      closeSlideOut()
    }
  }

  return (
    <PageLayoutContainer
      pageContextProps={{
        categories: categories || [],
        footerWidgets,
        staticPages
      }}
      position="relative"
    >
      <TopNav
        contentHeight="8vh"
        logo={logoComponent}
        onMenuHover={handleOnMenuHover}
        onMenuToggle={handleOnMenuToggle}
        toggleIcon={
          isHidden ? (
            <Box color="text.default">
              <MdOutlineMenu />
            </Box>
          ) : (
            <MdClose />
          )
        }
        zIndex={!isModalHidden && modalSize === 'full' ? 0 : 9000}
        {...{ menuItems, isHidden }}
      />
      <TopNavSpacer h="8vh" />
      {children}
      <CustomFooter />
    </PageLayoutContainer>
  )
}

export default CustomLayout
